import { useTranslation } from "react-i18next";
import { SvgIcon, Typography } from "@mui/material";
import { LabelPriceTotal } from "../LabelPriceTotal/LabelPriceTotal";
import { useStyle } from "./style";
import { CreditCard, Refresh } from "@mui/icons-material";

interface IParams {
    arePricesLoading?: boolean;
    monthlyTotal: number;
    oneOffTotal: number;
}

export const FlyingCartTotal = (props: IParams) => {
    const { t } = useTranslation(["cart", "common"]);
    const { classes } = useStyle();

    const { monthlyTotal, oneOffTotal, arePricesLoading } = props;

    return (
        <div className={classes.flyingCartTotal}>
            <Typography className={classes.flyingCartTotalTitle}>{t("cart:total")}:</Typography>
            <LabelPriceTotal
                hasBackground
                icon={<SvgIcon className={classes.creditCardIcon} component={CreditCard} inheritViewBox />}
                isLoading={arePricesLoading}
                label={t("cart:payToday")}
                price={oneOffTotal}
                sublabel={t("cart:activationFees")}
            />
            <LabelPriceTotal
                icon={<SvgIcon className={classes.refreshIcon} component={Refresh} inheritViewBox />}
                isLoading={arePricesLoading}
                label={t("cart:monthly")}
                price={monthlyTotal}
                sublabel={t("cart:fromFirstBill")}
            />
        </div>
    );
};
